<template>
  <v-navigation-drawer
    :value="rightBarStatus"
    fixed
    right
    app
    hide-overlay
    disable-resize-watcher
    dark
    class="pt-0 text-left disable-list-item-flex "
  >
    <v-list class="pt-0">
      <v-list-item class="px-2 py-1 item-right">
        <div class="text-sm-right ">
            <v-icon v-on:click.prevent="closeRightBar()">cancel</v-icon>
        </div>
      </v-list-item>
      <!-- <v-divider dark></v-divider> -->

      <template v-if="selectedLocation.name">
        <v-list-item class="location-list current px-2 py-3">
          <v-list-item-content>
            <v-list-item-title class="lh-0">{{ selectedLocation.name }}</v-list-item-title>
            <v-list-item-sub-title>{{ selectedLocation.address_line_1 }}</v-list-item-sub-title>
          </v-list-item-content>
          <v-icon v-on:click.prevent="removeLocation()" dark left>remove_circle</v-icon>
        </v-list-item>
        <v-divider class="mb-0 mt-0" dark></v-divider>
      </template>
      <template v-for="(item, index) in locationList">
        <v-list-item :key="item.id" class="location-list" @click="setLocation(item)">
          <v-list-item-content>
            <div class="py-3">
              <v-list-item-title class="lh-0">{{ item.name }}</v-list-item-title>
               <!-- <v-list-item-sub-title>{{ item.uuid }}</v-list-item-sub-title>  -->
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mb-0 mt-0" v-bind:key="`${index}-divider`" dark></v-divider>
      </template>
      <template v-if="locationList.length < 1">
        <v-list-item class="location-list" >
          <v-list-item-content>
            <div class="py-3">
              <v-list-item-title>Empty location.</v-list-item-title>
            </div>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {

    };
  },
  computed: {
    selectedLocation() {
      return this.getSelectedLocation;
    },
    ...mapGetters({
      rightBarStatus: 'navigation/rightNavStatus',
      locationList: 'location/list',
      getSelectedLocation: 'location/selected',
    }),
  },
  created() {
    //this.fetchLocations();
  },
  methods: {

    /**
    * Get all locations
    */
    fetchLocations() {
      //return false;
      // const url = `${Env.authorization_url}/unoapp_authorization/locations/me/`;
      // AuthApi.getApi(url)
      //   .then((res) => {
      //     this.setLocationList(res.data);
      //   })
      //   .catch((err) => {
      //     console.log('Unable to fetch locations.')
      //   });
    },

    /**
     * Select and store the location
     */
    setLocation(obj) {
      console.log(' No details for this now.')
      return false;
      this.spinner(true);
      this.selectLocation(obj);
      /**
       * after location is choosed get the apps for that location
       */
      const url = `${Env.authorization_url}/api/location/details`;
      AuthApi.postApi(url, { ref_location_id: obj.location.id })
        .then((res) => {
          this.spinner(false);
          const locationApps = [];
          const rawData = res.data.payload.location.apps;
          rawData.map((item) => {
            locationApps.push(item.app);
          });
          this.snackbar({
            text: 'Successfully set the location.',
            timeout: 4000,
            open: true,
          });
          this.selectLocationApps(locationApps);
        })
        .catch((errors) => {
          this.spinner(false);
          this.snackbar({
            text: 'Invalid Location.',
            timeout: 4000,
            open: true,
          });
          this.selectLocationApps([]);
        });
    },

    /**
     * Remove current selected location
     */
    removeLocation() {
      this.selectLocation({});
      this.selectLocationApps([]);
      this.snackbar({
        text: 'Location removed.',
        timeout: 4000,
        open: true,
      });
    },

    closeRightBar() {
      this.rightBar(false);
    },

    ...mapActions({
      rightBar: 'navigation/rightNavStatus',
      setLocationList: 'location/setList',
      selectLocation: 'location/selectAction',
      selectLocationApps: 'location/appsAction',
      snackbar: 'snackbar/snackbar',
      spinner: 'spinner/spinnerStatus',
    }),

  },
};
</script>

<style>
.location-list.current {
    background: #e06148;
}
.item-right .v-list__tile{
   flex-direction: row;
   justify-content: flex-end;
}
</style>

